// extracted by mini-css-extract-plugin
module.exports = {"WeekCalendar":"WeekCalendar___2mtG3"};